import { DEFAULT_PRICE_FORMAT } from '@ecp/common/src/const/price/priceConst';

export class PriceUtils {
  /**
   * 가격단위를 사용하는지 확인하는 함수
   */
  isUsePriceFormat(param) {
    return param !== DEFAULT_PRICE_FORMAT;
  }

  /**
   * priceFormat에 따라 price, formattedPrice 중 표기
   */
  getDisplayPrice({ priceFormat, price, formattedPrice }) {
    const self = this;
    if (self.isUsePriceFormat(priceFormat)) {
      return formattedPrice;
    } else {
      return price;
    }
  }

  /**
   * 가격단위 환산 함수
   */
  fromKrw(param, rate = 1) {
    return Math.trunc(param / rate);
  }

  /**
   * KRW 환산 함수
   */
  toKrw(param, rate = 1) {
    return param * rate;
  }
}
